/**
 * @generated SignedSource<<1a9a94588795751f1df2268c258ebdf4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutACHForm_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ControlledAddressForm_viewer">;
  readonly " $fragmentType": "CheckoutACHForm_viewer";
};
export type CheckoutACHForm_viewer$key = {
  readonly " $data"?: CheckoutACHForm_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutACHForm_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutACHForm_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ControlledAddressForm_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "c032be30a12ad39da240846da1173af5";

export default node;
